import { WSLoader } from "@wingspanhq/fe-component-library";
import React from "react";
import { WSQueries } from "../../../../query/WSQuery";
import { useQueryBankingAccount } from "../../../../query/bookkeeping/queries";
import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryPayoutSettings } from "../../../../query/payments/queries";
import { LayoutPaymentsSetup } from "../../../../shared/components/LayoutPaymentsSetup";
import { PayoutMethodType } from "../../../../shared/types/payments";
import { RouteComponentProps } from "../../types";
import { Form } from "./Form";
import { useMutationSubmit } from "./useMutationSubmit";

export const RouteType: React.FC<RouteComponentProps> = ({
  onBack,
  onNext,
  params
}) => {
  const userId = useUserId();
  const payoutSettingsQuery = useQueryPayoutSettings(userId);
  const [submit, submitMeta] = useMutationSubmit({ onSuccess: onNext });
  const queryBankingAccount = useQueryBankingAccount();

  if (queryBankingAccount.isLoading) {
    return <WSLoader.Spinner />;
  }

  return (
    <LayoutPaymentsSetup onBack={onBack}>
      <WSQueries queries={{ payoutSettingsQuery }}>
        {({ payoutSettingsQuery: { data: payoutSettings } }) => {
          const defaultPayoutMethods: PayoutMethodType[] = [
            PayoutMethodType.Instant,
            PayoutMethodType.Wallet,
            PayoutMethodType.ACH,
            PayoutMethodType.GiftCard
          ];

          return (
            <Form
              payoutSettings={payoutSettings}
              internalAccount={queryBankingAccount.data}
              payoutMethods={
                params?.availablePayoutMethods || defaultPayoutMethods
              }
              onSubmit={(selectedPayoutMethod, paymentCardId) => {
                submit({ selectedPayoutMethod, paymentCardId });
              }}
              error={submitMeta.error}
              isLoading={submitMeta.isLoading}
            />
          );
        }}
      </WSQueries>
    </LayoutPaymentsSetup>
  );
};
